import { Observable, of, EMPTY, Subject } from 'rxjs';
import { Directive, Input, Injector, OnInit, HostListener } from '@angular/core';
import { DiscussionListComponent, DiscussionListDirective } from '@farris/discussion-group';
import { ViewModel, Change, ChangeType } from '@farris/devkit';
import { catchError, debounceTime } from 'rxjs/operators';
const KEY_UISTATE_REPLY_MESSAGE = 'DISCUSSION_REPLY_MESSAGE_INFO';
const KEY_MESSAGE_ON_COMMENT_ADD = 'onCommentAdd';
@Directive({
  selector: '[farris-discussion-list-binding]'
})
export class FarrisDiscussionListBindingDirective implements OnInit {
  private queryCommentsSubject: Subject<any>;
  /**
   * è·åç¨æ·å½ä»¤
  */
  @Input('commentsQueryCommand') commentsQueryCommand: string;
  constructor(public injector: Injector, public discussionListComponent: DiscussionListComponent, public viewModel: ViewModel, public discussionListDirective: DiscussionListDirective) {
    this.queryCommentsSubject = new Subject();
    this.queryCommentsSubject.pipe(debounceTime(500)).subscribe(() => {
      this.queryComments();
    });
  }
  ngOnInit(): void {
    this.viewModel.frameContext.appContext.messagePipe.subscribe((message: any) => {
      if (message === KEY_MESSAGE_ON_COMMENT_ADD) {
        this.queryComments();
      }
    });
    this.viewModel.bindingData.changes.subscribe((change: Change) => {
      if (change.type === ChangeType.Load || change.type === ChangeType.SelectionChanged) {
        // this.queryComments();
        this.queryCommentsSubject.next();
      }
    });
    this.queryCommentsSubject.next();
  }
  /**
   * æ¥è¯¢è¯è®º
   */
  private queryComments(pageIndex?: number, pageSize?: number) {
    if (typeof pageIndex === 'undefined') {
      pageIndex = (this.discussionListComponent.pageIndex - 1) || 0;
    }
    if (typeof pageSize === 'undefined') {
      if (this.discussionListComponent.supportPaging) {
        pageSize = this.discussionListComponent.pageSize;
      } else {
        // ä¸åé¡µï¼pageSizeååç«¯çº¦å®ä¼ æå¤§æ°
        pageSize = 10000;
      }
    }
    this.execute(this.commentsQueryCommand, { pageIndex, pageSize }).pipe(
      catchError(e => EMPTY)
    ).subscribe(result => {
      if (!result) {
        return;
      }
      const { comments = [], pageIndex = 0, pageSize = 10, totalCount = 0 } = result;
      this.discussionListComponent.pageIndex = parseInt(pageIndex) + 1;
      if (this.discussionListComponent.supportPaging) {
        this.discussionListComponent.pageSize = pageSize;
      }
      this.discussionListComponent.total = totalCount;
      this.discussionListDirective.discussionListData = result;
    });
  }
  /**
   * åå¤æ¶æ¯
   * @param event event
   */
  @HostListener('replyMessage', ['$event'])
  public replyMessagedHandler(event: any) {
    this.viewModel.frameContext.root.viewModel.uiState.setPropertyValue(KEY_UISTATE_REPLY_MESSAGE, event);
  }
  /**
   * åæ¢é¡µç 
   * @param event event
   */
  @HostListener('pageChanged', ['$event'])
  public pageChangedHandler(event: any) {
    const { pageIndex = 1, pageSize = 10 } = event.pageInfo || {};
    this.queryComments(pageIndex - 1, pageSize);
  }
  /**
   * æ§è¡å½ä»¤
   * @param commandName å½ä»¤åç§°
   */
  private execute(commandName: string, params?: any): Observable<any> {
    if (!commandName || commandName === '' || commandName === 'undefined') {
      return of(null);
    }
    const paths = commandName.split('.');
    let func = null;
    paths.forEach(path => {
      func = func && func[path] || this[path];
    });
    if (typeof func === 'function') {
      return func(params);
    }
    return of(null);
  }
}
